import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutFuelInterfaceLookup extends Layout {
    sourceFuelInterfaceLookup: DataSource;
    tableFuelVendors: Table;
}
